import { render, staticRenderFns } from "./DxMonthlyComponent.vue?vue&type=template&id=368d73d2&scoped=true&"
import script from "./DxMonthlyComponent.vue?vue&type=script&lang=js&"
export * from "./DxMonthlyComponent.vue?vue&type=script&lang=js&"
import style0 from "./DxMonthlyComponent.vue?vue&type=style&index=0&id=368d73d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368d73d2",
  null
  
)

export default component.exports